import emailjs from '@emailjs/browser'

const SERVICE_ID = import.meta.env.VITE_EMAILJS_SERVICE_ID
const PUBLIC_KEY = import.meta.env.VITE_EMAILJS_PUBLIC_KEY

// Template IDs for different forms
const TEMPLATES = {
  contact: import.meta.env.VITE_EMAILJS_CONTACT_TEMPLATE || 'template_contact',
  prayer: import.meta.env.VITE_EMAILJS_PRAYER_TEMPLATE || 'template_prayer',
  visit: import.meta.env.VITE_EMAILJS_VISIT_TEMPLATE || 'template_visit',
  rsvp: import.meta.env.VITE_EMAILJS_RSVP_TEMPLATE || 'template_rsvp',
  newsletter: import.meta.env.VITE_EMAILJS_NEWSLETTER_TEMPLATE || 'template_newsletter',
  connectCard: import.meta.env.VITE_EMAILJS_CONNECT_CARD_TEMPLATE || 'template_connect_card',
}

// Initialize EmailJS
export const initEmailJS = () => {
  emailjs.init(PUBLIC_KEY)
}

// Send email using a template
export const sendEmail = async (templateType, templateParams) => {
  try {
    const templateId = TEMPLATES[templateType] || templateType
    const response = await emailjs.send(SERVICE_ID, templateId, templateParams)
    return { success: true, response }
  } catch (error) {
    console.error('Email send error:', error)
    return { success: false, error }
  }
}

// Contact form submission
export const sendContactEmail = async (data) => {
  return sendEmail('contact', {
    from_name: data.name,
    from_email: data.email,
    phone: data.phone || 'Not provided',
    subject: data.subject,
    message: data.message,
  })
}

// Prayer request submission
export const sendPrayerEmail = async (data) => {
  return sendEmail('prayer', {
    from_name: data.name,
    from_email: data.email,
    prayer_request: data.prayerRequest,
    is_confidential: data.isConfidential ? 'Yes' : 'No',
  })
}

// Visit registration
export const sendVisitEmail = async (data) => {
  return sendEmail('visit', {
    from_name: data.name,
    from_email: data.email,
    phone: data.phone,
    visit_date: data.visitDate,
    service_time: data.serviceTime,
    family_size: data.familySize,
    children_ages: data.childrenAges || 'N/A',
    how_heard: data.howHeard,
    questions: data.questions || 'None',
  })
}

// Event RSVP
export const sendRSVPEmail = async (data) => {
  return sendEmail('rsvp', {
    from_name: data.name,
    from_email: data.email,
    event_name: data.eventName,
    event_date: data.eventDate,
    attendees: data.attendees,
    notes: data.notes || 'None',
  })
}

// Newsletter signup
export const sendNewsletterWelcome = async (data) => {
  return sendEmail('newsletter', {
    to_email: data.email,
    to_name: data.name || 'Friend',
  })
}

// Connect Card (new visitor) submission
export const sendConnectCardEmail = async (data) => {
  return sendEmail('connectCard', {
    from_name: `${data.firstName} ${data.lastName}`.trim(),
    from_email: data.email,
    phone: data.phone || 'Not provided',
    service_attended: data.serviceAttended,
    visitor_type: data.visitorType === 'first_time' ? 'First time visitor' : 'Returning visitor',
    interests: data.interests?.length ? data.interests.join(', ') : 'None selected',
    message: data.message || 'None',
  })
}
